import { render } from "./MobileTabs.vue?vue&type=template&id=5dc16912"
import script from "./MobileTabs.vue?vue&type=script&lang=js"
export * from "./MobileTabs.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/dgvt/dgvt-fuchs.de/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__